import React from 'react';
import { useIntl } from 'react-intl';
import { formatDistance, formatQuantity } from '../format';
import type { ModelSize } from '../format';
import { DIMENSION_AXES, axisColors, cssColor } from '../viewport';
import type { DimensionAxis } from '../viewport';
import { AxisLetter, LabelPill } from './SceneLabels.styled';

export interface DimensionLabelsProps {
  size: ModelSize;
  isDark: boolean;
  attach: (axis: DimensionAxis, element: HTMLDivElement | null) => void;
}

/** The part's extents, each pinned by the stage to the middle of its guide. */
export const DimensionLabels: React.FC<DimensionLabelsProps> = ({ size, isDark, attach }) => {
  const intl = useIntl();
  const colors = axisColors(isDark);
  return (
    <>
      {DIMENSION_AXES.map((axis) => {
        const tint = cssColor(colors[axis]);
        return (
          <LabelPill
            key={axis}
            ref={(element) => attach(axis, element)}
            $tint={tint}
            data-testid={`model-viewer__dimension-${axis}`}
          >
            <AxisLetter $tint={tint}>{axis.toUpperCase()}</AxisLetter>
            {`${formatQuantity(intl, size[axis])} mm`}
          </LabelPill>
        );
      })}
    </>
  );
};

export interface MeasureLabelProps {
  distance: number;
  tint: string;
  attach: (element: HTMLDivElement | null) => void;
}

export const MeasureLabel: React.FC<MeasureLabelProps> = ({ distance, tint, attach }) => {
  const intl = useIntl();
  return (
    <LabelPill ref={attach} $tint={tint} data-testid="model-viewer__measure-label">
      {`${formatDistance(intl, distance)} mm`}
    </LabelPill>
  );
};
